import { useState } from 'react';

import { Feedback } from '@cartwhl/common/types';
import Input from '@cartwhl/ui/atoms/Input';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import AnimationPreview from '@cartwhl/ui/molecules/AnimationPreview';
import Modal from '@cartwhl/ui/molecules/Modal';

import { animationGenerationStore, noticesStore } from 'stores';

export default function FeedbackModal({
  close,
  payload,
}: {
  close: () => void;
  payload: Feedback;
}) {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const submitFeedback = async () => {
    setLoading(true);
    await animationGenerationStore.setFeedback({ ...payload, comment });
    noticesStore.success('Successfully reported');
    close();
  };

  return (
    <Modal
      title={`Report ${
        payload.sentiment === 'negative' ? 'broken' : 'great'
      } animation`}
      open={true}
      closeOnClickOutside={false}
    >
      <div className="mb-8 flex gap-6" id="feedback-modal">
        <AnimationPreview
          className="max-w-[145px]"
          active={false}
          mediaType="video"
          mediaPath={payload.mp4Path}
          aspect="animation"
        />
        <div className="pt-4">
          <Text variant="studio/body/medium/md" as="h2">
            {payload.prompt}
          </Text>
        </div>
      </div>
      <div>
        <Input
          as="textarea"
          name="feedback"
          placeholder="Anything else we should know?"
          label="Additional comments (optional)"
          onChange={(e) => setComment(e.target.value)}
        />
      </div>
      <div className="mt-6 flex justify-end">
        <Button loading={loading} variant="primary" onClick={submitFeedback}>
          Done
        </Button>
      </div>
    </Modal>
  );
}
